import React from "react";
import classNames from "classnames";
import { WoWAppFAQ } from "components/DesktopAppSplashPage/WoWAppFAQ";

interface WoWAppContentProps {
  className?: string;
  downloadButton?: React.ReactNode;
}

// 1px rule, opaque at the centre and fading out to both edges.
const RULE = "h-px w-full bg-[linear-gradient(90deg,rgba(56,56,100,0)_0%,#383864_50%,rgba(56,56,100,0)_100%)]";

export function WoWAppContent({ className, downloadButton }: WoWAppContentProps) {
  return (
    <div className={classNames("mt-[120px] flex w-full flex-col gap-[120px] font-inter", className)}>
      <section className="flex min-h-[182px] flex-col justify-between">
        <div className={RULE} />
        <div className="flex flex-col items-center text-center">
          <h2 className="m-0 text-[24px] font-extrabold leading-normal text-white">We&rsquo;re Just Getting Started</h2>
          <p className="m-0 mt-[14px] text-[16px] font-normal leading-normal text-lavender-50">
            Classic Support, Performances Tools, and More Coming soon
          </p>
        </div>
        <div className={RULE} />
      </section>

      <section>
        <WoWAppFAQ />
        {downloadButton && <div className="mt-[60px] flex justify-center">{downloadButton}</div>}
      </section>
    </div>
  );
}

export default WoWAppContent;
